<script>
  /**
   * Specify the pictogram title.
   * @type {string}
   */
  export let title = undefined;

  $: labelled =  $$props["aria-label"] || $$props["aria-labelledby"] || $$props["title"];
  $: attributes = {
    "aria-hidden": labelled ? undefined : true,
    role: labelled ? "img" : undefined,
    focusable: Number($$props["tabindex"]) === 0  ? true : undefined,
  };
</script>

<svg
  preserveAspectRatio="xMidYMid meet"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 32 32"
  width="64"
  height="64"
  fill="currentColor"
  {title}
  {...attributes}
  {...$$restProps}>
  <path d="M4,18.36c-1.301,0-2.36-1.059-2.36-2.36S2.699,13.64,4,13.64S6.36,14.699,6.36,16	C6.36,17.302,5.301,18.36,4,18.36z M4,14.36c-0.904,0-1.64,0.736-1.64,1.64c0,0.904,0.736,1.64,1.64,1.64S5.64,16.904,5.64,16	S4.904,14.36,4,14.36z M7,12.36c-1.301,0-2.36-1.059-2.36-2.36S5.699,7.64,7,7.64S9.36,8.699,9.36,10S8.301,12.36,7,12.36z M7,8.36	c-0.904,0-1.64,0.736-1.64,1.64S6.096,11.64,7,11.64S8.64,10.904,8.64,10S7.904,8.36,7,8.36z M7,24.36	c-1.301,0-2.36-1.059-2.36-2.36S5.699,19.64,7,19.64S9.36,20.698,9.36,22S8.301,24.36,7,24.36z M7,20.36	c-0.904,0-1.64,0.735-1.64,1.64S6.096,23.64,7,23.64S8.64,22.904,8.64,22S7.904,20.36,7,20.36z M20.36,10	c0-0.199-0.161-0.36-0.36-0.36h-8c-0.199,0-0.36,0.161-0.36,0.36s0.161,0.36,0.36,0.36h8C20.199,10.36,20.36,10.199,20.36,10z M20.36,22c0-0.199-0.161-0.36-0.36-0.36h-8c-0.199,0-0.36,0.161-0.36,0.36s0.161,0.36,0.36,0.36h8	C20.199,22.36,20.36,22.199,20.36,22z M17.36,16c0-0.199-0.161-0.36-0.36-0.36H9c-0.199,0-0.36,0.161-0.36,0.36S8.801,16.36,9,16.36	h8C17.199,16.36,17.36,16.199,17.36,16z M24.237,27.648l5.958-11c0.22-0.406,0.22-0.89,0-1.295l-5.958-11	c-0.238-0.439-0.696-0.712-1.195-0.712H11v0.72h12.042c0.234,0,0.45,0.128,0.562,0.335l5.958,11c0.104,0.19,0.104,0.418,0,0.609	l-5.958,11c-0.112,0.207-0.328,0.335-0.562,0.335H11v0.721h12.042C23.541,28.36,23.999,28.087,24.237,27.648z"></path>
</svg>